// extracted by mini-css-extract-plugin
export default {"button":"ResetChangesButton_button__YcqKd"};